/* eslint-disable no-dupe-keys */
export default {
  service_provider_transaction_record: {
    name: '运营商交易流水',
    // 属性（一般与对象内容匹配）
    prop: {
      trade_number: '交易单号',
      service_provider_id: '运营商',
      transaction_type: '交易类型',
      amount: '交易金额',
      admin_id: '操作人',
      before_balance: '交易前余额',
      after_balance: '交易后余额',
      note: '备注',
      created_at: '登记时间',
      updated_at: '更新时间',
      accounting_date: '账单日期',
      accounting_date_range: '账单日期',
      accounting_begin_date: '账单开始日期',
      accounting_end_date: '账单结束日期',
      ev_charging_station_id: '充电站',
      manual_settlement_type: '补录类型',
      withdrawn_amount: '已提现金额',
      withdrawable_amount: '剩余可提现金额',
      current_transaction_amount: '本次交易金额',
      transaction_record_amount: '流水交易金额',
      ev_charging_station: '结算站',
      transaction_type: '交易类型',
      settlement_type: '结算类型',
      charge_channel: '充电渠道'
    },
    // Enum的属性
    transaction_types: {
      withdraw: '提现(支出)',
      settlement: '结算(净收入)',
      manual_settlement: '手动结算(补登)'
    },
    settlement_types: {
      station_order: '订单结算',
      station_idle_fee_bill: '占位费结算',
      station_order_discount: '优惠结算',
      station_charging_package: '充电包结算'
    },
    manual_settlement_types: {
      ev_charging_station: '充电站账单',
      service_provider: '商家账单'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '交易单号/备注',
      select_charge_channel: '选择充电渠道'
    },
    // 详情页标签
    labels: {
      total_amount: '总额',
      shop_service_provider: '商家'
    }
  }
}
